import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  dropdownTrigger: {
    borderWidth: 1,
    borderColor: colors.backgroundL1,
    borderRadius: theme.borderRadius.full,
    padding: theme.spacing[4],
    backgroundColor: colors.backgroundL1Alpha,
  },
  dropdownItemText: {
    paddingHorizontal: theme.spacing[2],
  },
  dropdownContent: {
    borderRadius: theme.borderRadius.xs,
    borderWidth: 1,
    borderColor: colors.borderPrimary,
  },
}));
